import React, { useEffect, useState } from 'react';
import {
  Table,
  Tbody,
  Tr,
  Td,
  TableContainer,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box
} from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { BASE_URL } from '../../../Globalapi/Globalapi';

const AnnualReport = () => {
  const { user_id: paramUserId } = useParams(); // Get the user ID from the URL and rename it
  const [subjects, setSubjects] = useState([]);

  useEffect(() => {
    // Use the extracted user ID
    const user_id = paramUserId;

    // Fetch data from the API
    fetch(`${BASE_URL}/student/exam_result_graph.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ pass: user_id }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          // Set the subjects state to the fetched data
          setSubjects(data.data);
        } else {
          console.error('No data found');
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, [paramUserId]);

  // Get exam marks for each subject and category
  const getExamMarks = (subject, category) => {
    const exam = subjects.find((exam) => exam.subject === subject && exam.exam_category === category);
    return exam ? Number(exam.student_scored_marks) : 0;
  };

  // Calculate the percentage for each subject
  const getExamPercentage = (subject) => {
    const firstTerm = getExamMarks(subject, 'First Terminal Exam');
    const secondTerm = getExamMarks(subject, 'Second Terminal Exam');
    const annualExam = getExamMarks(subject, 'Annual Exam');

    // 25% of First Term, 25% of Second Term, 50% of Annual Exam
    const total = (0.25 * firstTerm) + (0.25 * secondTerm) + (0.5 * annualExam);
    return total.toFixed(2);
  };

  return (
    <Accordion allowToggle>
      <AccordionItem>
        <h2>
          <AccordionButton>
            <Box
              flex="1"
              textAlign="center"
              width="200px"
              height="50px"
              bg="gray.200"
              padding="0"
              borderRadius="md"
              fontWeight="bold"
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontSize="lg"
              lineHeight="1.2"
            >
              Cumulative Result Sheet
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel pb={4}>
          <TableContainer padding="20px" maxWidth="1000px" margin="0 auto">
            <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }} size="sm" border="1px solid #d4c2c2" width="100%">
              <Tbody>
                <Tr>
                  <Td
                    fontWeight="bold"
                    border="1px solid #d4c2c2"
                    textAlign="center"
                    verticalAlign="middle"
                  >
                    Subjects
                  </Td>
                  <Td fontWeight="bold" border="1px solid #d4c2c2" textAlign="center" verticalAlign="middle">
                    First Term Mark (25%)
                  </Td>
                  <Td fontWeight="bold" border="1px solid #d4c2c2" textAlign="center" verticalAlign="middle">
                    Second Term Mark (25%)
                  </Td>
                  <Td fontWeight="bold" border="1px solid #d4c2c2" textAlign="center" verticalAlign="middle">
                    Annual Exam Mark (50%)
                  </Td>
                  <Td fontWeight="bold" border="1px solid #d4c2c2" textAlign="center" verticalAlign="middle">
                    Result Percentage (out of 100)
                  </Td>
                </Tr>

                {/* Render subjects and marks */}
                {subjects.map((subject) => (
                  <Tr key={subject.exam_id}>
                    <Td border="1px solid #d4c2c2" textAlign="center" fontWeight="bold" verticalAlign="middle">
                      {subject.subject}
                    </Td>
                    <Td border="1px solid #d4c2c2" textAlign="center">{getExamMarks(subject.subject, 'First Terminal Exam')}</Td>
                    <Td border="1px solid #d4c2c2" textAlign="center">{getExamMarks(subject.subject, 'Second Terminal Exam')}</Td>
                    <Td border="1px solid #d4c2c2" textAlign="center">{getExamMarks(subject.subject, 'Annual Exam')}</Td>
                    <Td border="1px solid #d4c2c2" textAlign="center">
                      {getExamPercentage(subject.subject)}%
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};

export default AnnualReport;
